var map = {
	"./arrowDown.svg": "971d",
	"./arrowUp.svg": "453f",
	"./card-liulan.svg": "03e0",
	"./dianhua-2.svg": "9c55",
	"./dizhi.svg": "2147",
	"./gouwuche.svg": "7f30",
	"./guide.svg": "6683",
	"./homeIcon.svg": "1937",
	"./myOrder.svg": "7236",
	"./sousuo.svg": "ceb2",
	"./wode.svg": "3756",
	"./youxiang.svg": "798a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";